// Yaz kampanyası yapılandırması — tek kaynak.
// endDate geçince tüm kampanya bileşenleri otomatik gizlenir.

export const SUMMER_CAMPAIGN = {
  id: 'summer-klima-2026',
  active: true,
  endDate: '2026-06-20T23:59:59+03:00',
  title: 'Yaz Kampanyası',
  serviceName: 'Profesyonel Detaylı Klima Bakımı',
  price: 1500,
  priceDisplay: '1.500 TL',
  endDateDisplay: '20 Haziran 2026',
  detailPath: '/servislerimiz/klima-bakimi',
  whatsappText:
    'Merhaba, Yaz Kampanyası kapsamında 1.500 TL detaylı klima bakımı hakkında bilgi almak istiyorum.',
  storageKey: 'uk-campaign-summer-2026-dismissed',
  checklist: [
    'Filtre ve evaporatör temizliği',
    'Gaz basıncı kontrolü',
    'Performans testi',
    'Garantili işçilik',
  ],
  barMarqueeText:
    'Detaylı Klima Bakımı 1.500 TL · 20 Haziran\'a kadar · Aynı gün servis',
};

export function isCampaignActive(campaign = SUMMER_CAMPAIGN) {
  if (!campaign?.active) return false;
  const end = new Date(campaign.endDate).getTime();
  return !Number.isNaN(end) && Date.now() <= end;
}

export default SUMMER_CAMPAIGN;
